import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import {
  Box,
  Collapse,
  Flex,
  Heading,
  HStack,
  IconButton,
  Image,
  Input,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import Checkbox from "../Helpers/Checkbox";
import { ChangeEvent, useEffect, useState } from "react";
import { setSaveProportions, setScales } from "../../Store/ConstructorReducer";
import { setFocusLocked } from "../../Store/GlobalReducer";
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import { colors } from "../../Theme";
import { mapNames } from "../../Utils";
import SavePropsIcon from "../Images/saveProportions.png";
import {
  ModalsName,
  setModalOpen,
  setTextureKey,
} from "../../Store/ModalsReducer";

const ItemInfo = (props: {
  item: { x: number; y: number; z: number };
  itemKey: string;
  type: string;
}) => {
  const dispatch = useAppDispatch();
  const scales = useAppSelector((state) => state.main.scales);

  const saveProportions = useAppSelector((state) => state.main.saveProportions);

  const [_x, _setX] = useState(`${Math.round(props.item.x)}`);
  const [_y, _setY] = useState(`${Math.round(props.item.y)}`);
  const [_z, _setZ] = useState(`${Math.round(props.item.z)}`);

  useEffect(() => {
    if (
      Math.round(props.item.x) !==
      parseFloat(_x.replace("мм", "").replace(",", "."))
    ) {
      _setX(`${Math.round(props.item.x)}`);
    }
    if (
      Math.round(props.item.y) !==
      parseFloat(_y.replace("мм", "").replace(",", "."))
    ) {
      _setY(`${Math.round(props.item.y)}`);
    }
    if (
      Math.round(props.item.z) !==
      parseFloat(_z.replace("мм", "").replace(",", "."))
    ) {
      _setZ(`${Math.round(props.item.z)}`);
    }
  }, [props.item]);

  const handleChange = (axis: "x" | "y" | "z", value: string) => {
    const newVal = parseFloat(value.replace(",", "."));

    if (!isNaN(newVal)) {
      const angle = rotations[props.itemKey];
      let newAxis = axis;
      if ((angle / 90) % 2 !== 0) {
        if (axis === "x") newAxis = "z";
        else if (axis === "z") newAxis = "x";
      }
      // console.log(newAxis, props.item[axis] / scales[props.itemKey][axis], props.item[axis], scales[props.itemKey][axis]);
      dispatch(
        setScales({
          key: props.itemKey,
          scale: {
            ...scales[props.itemKey],
            [newAxis]:
              newVal / (props.item[axis] / scales[props.itemKey][axis]),
          },
        })
      );
    }
  };

  const rotations = useAppSelector((state) => state.main.rotations);
  const types = useAppSelector((state) => state.main.types);

  const setX = () => {
    dispatch(setFocusLocked(false));
    handleChange("x", _x);
  };

  const setZ = () => {
    dispatch(setFocusLocked(false));
    handleChange("z", _z);
  };

  return (
    <VStack w="100%" p="10px">
      <HStack w="100%" h="5rem" justify="space-between">
        <HStack w="70%">
          <Text fontWeight="bold">{props.type}</Text>
          { types[props.itemKey] !== 'group' && <Image
            w="3rem"
            src="/system/modules/OnlineEditor/images/icons/texture_change.png"
            alt="Сменить текстуру"
            onClick={() => {
              dispatch(setTextureKey(props.itemKey));
              dispatch(setModalOpen({ key: ModalsName.TEXTURES, value: true }));
            }}
            cursor="pointer"
          />}
        </HStack>

        <HStack align="center">
          <Image w="1.25rem" src={SavePropsIcon} />
          <Checkbox
            checked={saveProportions[props.itemKey]}
            onChange={(ev: ChangeEvent<HTMLInputElement>) => {
              dispatch(
                setSaveProportions({
                  key: props.itemKey,
                  value: ev.target.checked,
                })
              );
            }}
          />
        </HStack>
      </HStack>
      <Flex w="100%" justify="space-between">
        <HStack justify="space-between" w="30%">
          <Text color="blue" fontSize="2rem">
            X:
          </Text>
          <form
            onSubmit={(ev) => {
              ev.preventDefault();
              setX();
            }}
          >
            <Input
              textAlign="right"
              onFocus={() => dispatch(setFocusLocked(true))}
              onKeyPress={() => dispatch(setFocusLocked(true))}
              // onBlur={() => setX()}
              borderColor={colors.brown}
              borderRadius={0}
              value={_x}
              fontSize="2rem"
              onChange={(ev: ChangeEvent<HTMLInputElement>) => {
                _setX(
                  `${parseFloat(
                    ev.target.value.replace(",", ".").replace(/[^0-9]*/gi, "")
                  )}`
                );
              }}
            />
          </form>
        </HStack>
        <HStack justify="space-between" w="30%">
          <Text color="green" fontSize="2rem">
            Y:
          </Text>
          <form
            onSubmit={(ev) => {
              ev.preventDefault();
              dispatch(setFocusLocked(false));
              handleChange("y", _y);
            }}
          >
            <Input
              textAlign="right"
              onFocus={() => dispatch(setFocusLocked(true))}
              onKeyPress={() => dispatch(setFocusLocked(true))}
              // onBlur={() => {
              //   handleChange("y", _y);
              //   dispatch(setFocusLocked(false));
              // }}
              borderColor={colors.brown}
              borderRadius={0}
              fontSize="2rem"
              value={_y}
              onChange={(ev: ChangeEvent<HTMLInputElement>) => {
                _setY(
                  `${parseFloat(
                    ev.target.value.replace(",", ".").replace(/[^0-9]*/gi, "")
                  )}`
                );
              }}
            />
          </form>
        </HStack>
        <HStack justify="space-between" w="30%">
          <Text color="red" fontSize="2rem">
            Z:
          </Text>
          <form
            onSubmit={(ev) => {
              ev.preventDefault();
              setZ();
            }}
          >
            <Input
              textAlign="right"
              onFocus={() => dispatch(setFocusLocked(true))}
              onKeyPress={() => dispatch(setFocusLocked(true))}
              // onBlur={() => {
              //   setZ();
              // }}
              borderColor={colors.brown}
              borderRadius={0}
              value={_z}
              fontSize="2rem"
              onChange={(ev: ChangeEvent<HTMLInputElement>) => {
                _setZ(
                  `${parseFloat(
                    ev.target.value.replace(",", ".").replace(/[^0-9]*/gi, "")
                  )}`
                );
              }}
            />
          </form>
        </HStack>
      </Flex>
    </VStack>
  );
};

const ObjectInfo = () => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const movingNodes = useAppSelector((state) => state.main.movingNodes);
  const objectInfo = useAppSelector((state) => state.main.objectInfo);
  const types = useAppSelector((state) => state.main.types);

  const counter: { [key: string]: number } = {};
  const names: { [key: string]: string } = {};
  for (const key in types) {
    const type = types[key];
    if (!counter[type]) counter[type] = 1;
    else counter[type] += 1;
    names[key] = `${mapNames(types[key], false)} ${counter[type]}`;
  }

  return (
    <Box pos="relative" w="100%">
      <Heading
        cursor="pointer"
        size="md"
        variant="editor"
        textAlign="center"
        onClick={onToggle}
      >
        Свойства объекта
      </Heading>
      <IconButton
        pos="absolute"
        top={".5rem"}
        right={".5rem"}
        icon={
          isOpen ? (
            <ChevronUpIcon boxSize={"3rem"} />
          ) : (
            <ChevronDownIcon boxSize={"3rem"} />
          )
        }
        aria-label={isOpen ? "Свернуть" : "Раскрыть"}
        onClick={onToggle}
      />
      <Collapse unmountOnExit={false} in={isOpen} animateOpacity>
        <VStack pos="relative" w="100%" h="50%">
          {(movingNodes.length === 0 || objectInfo.length === 0) && (
            <Text fontStyle="italic">Выберите объект</Text>
          )}
          {Object.keys(objectInfo).map((key: string) => (
            <ItemInfo
              item={objectInfo[key]}
              key={`info${key}`}
              itemKey={key}
              type={names[key]}
            />
          ))}
        </VStack>
      </Collapse>
    </Box>
  );
};

export default ObjectInfo;
